import {
  userRepository,
  songRepository,
  tagRepository,
  internalStripeRepository,
  iubendaRepository,
  aiRepository,
} from './network';
import {
  UserServiceImpl,
  SongServiceImpl,
  TagServiceImpl,
  StripeServiceImpl,
  IubendaServiceImpl,
  AIServiceImpl,
} from './useCases';

const userService: UserServiceImpl = new UserServiceImpl(userRepository);
const songService: SongServiceImpl = new SongServiceImpl(songRepository);
const tagService: TagServiceImpl = new TagServiceImpl(tagRepository);
const aiService: AIServiceImpl = new AIServiceImpl(aiRepository);
const stripeService: StripeServiceImpl = new StripeServiceImpl(
  internalStripeRepository
);
const iubendaService: IubendaServiceImpl = new IubendaServiceImpl(
  iubendaRepository
);

const services = {
  userService,
  songService,
  tagService,
  aiService,
  stripeService,
  iubendaService,
};
export default services;
export {
  userService,
  songService,
  tagService,
  aiService,
  stripeService,
  iubendaService,
};
